import { DefaultQueryParams } from '@frontend/api-utils';
import { StockReplenishmentExtendedClient } from '@frontend/stock/api';
import { StockReplenishmentExtended } from '@frontend/stock/types';
import { useEffect, useState } from 'react';

import { VendingProductsNeedingRefillListCardProps } from './vending-products-needing-refill-list-card.component';

const REFILL_LIMIT = 5;

export const useVendingProductsNeedingRefillListCard = (props: VendingProductsNeedingRefillListCardProps) => {
    const [items, setItems] = useState<StockReplenishmentExtended[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        StockReplenishmentExtendedClient.fetchStockReplenishmentsExtended({
            [DefaultQueryParams.ACCOUNT_ID]: props.accountId,
            [DefaultQueryParams.SIZE]: String(REFILL_LIMIT),
            [DefaultQueryParams.SORTFIELD]: 'filled_min_percentage',
            [DefaultQueryParams.SORTDIRECTION]: 'asc',
            below_minimum: '1'
        })
            .then((response) => {
                if (!cancelled) {
                    setItems(response.results ?? []);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setItems([]);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    return { items, isLoading };
};
